import { render, staticRenderFns } from "./ConfirmArchiveModal.vue?vue&type=template&id=60b73dcb"
import script from "./ConfirmArchiveModal.vue?vue&type=script&lang=js"
export * from "./ConfirmArchiveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports